// assets/dynamic-sections.js
;(function dynamicSectionsModule() {
  if (typeof window === 'undefined') return

  const RV_STORAGE_KEY = 'rv:products'

  const toNum = (value) => (typeof value === 'number' ? value : Number(value))

  function hydrateSection(section) {
    if (typeof window.setupEmblaOnResize === 'function') {
      window.setupEmblaOnResize()
    }
    section.dispatchEvent(
      new CustomEvent('ui:hydrate', {
        bubbles: true,
        detail: { target: section },
      }),
    )
  }

  function initRecentlyViewed(root = document) {
    root.querySelectorAll('[data-recently-viewed]').forEach((section) => {
      if (section.dataset.initialized === 'true') return

      section.dataset.initialized = 'true'

      const limit = parseInt(section.dataset.limit || '4', 10)
      const container = section.querySelector('[data-rv-container]')
      if (!container) {
        section.style.display = 'none'
        return
      }

      const hook = document.getElementById('rv-product')
      const currentId = hook && hook.dataset.id ? toNum(hook.dataset.id) : null

      let list = []
      try {
        list = JSON.parse(localStorage.getItem(RV_STORAGE_KEY) || '[]') || []
      } catch (error) {
        list = []
      }

      const seen = new Set()
      const candidates = []
      for (const entry of list) {
        if (!entry || !entry.id || !entry.handle) continue
        const pid = toNum(entry.id)
        if (currentId && pid === currentId) continue
        if (seen.has(pid)) continue
        seen.add(pid)
        candidates.push({ id: pid, handle: entry.handle })
        if (candidates.length >= limit) break
      }

      if (candidates.length < limit) {
        section.style.display = 'none'
        return
      }

      Promise.all(
        candidates.slice(0, limit).map((entry) =>
          fetch(`/products/${encodeURIComponent(entry.handle)}?view=card`)
            .then((res) => (res.ok ? res.text() : ''))
            .catch(() => ''),
        ),
      )
        .then((htmlSnippets) => {
          const fragment = document.createDocumentFragment()
          htmlSnippets.filter(Boolean).forEach((html) => {
            const slide = document.createElement('div')
            slide.className = 'embla__slide group flex-[0_0_75%] tab:flex-[0_0_50%] pro:flex-[0_0_auto]'
            slide.innerHTML = html
            fragment.appendChild(slide)
          })

          if (!fragment.childNodes.length) {
            section.style.display = 'none'
            return
          }

          container.appendChild(fragment)
          section.classList.remove('hidden')
          hydrateSection(section)
        })
        .catch(() => {
          section.style.display = 'none'
        })
    })
  }

  const recommendationControllers = new Map()

  function initRecommendations(root = document) {
    root.querySelectorAll('[data-product-recommendations]').forEach((section) => {
      const url = section.dataset.url
      if (!url || section.dataset.loading === 'true') return

      section.dataset.loading = 'true'

      if (recommendationControllers.has(section)) {
        recommendationControllers.get(section).abort()
      }

      const controller = new AbortController()
      recommendationControllers.set(section, controller)

      fetch(url, { signal: controller.signal })
        .then((res) => (res.ok ? res.text() : ''))
        .then((html) => {
          if (!html) return
          const doc = new DOMParser().parseFromString(html, 'text/html')
          const fresh = doc.querySelector('[data-product-recommendations]')
          if (!fresh) return

          section.innerHTML = fresh.innerHTML
          hydrateSection(section)
        })
        .catch((error) => {
          if (error.name === 'AbortError') return
        })
        .finally(() => {
          if (recommendationControllers.get(section) === controller) {
            recommendationControllers.delete(section)
          }
          delete section.dataset.loading
        })
    })
  }

  function init(root = document) {
    initRecentlyViewed(root)
    initRecommendations(root)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true })
  } else {
    init()
  }

  document.addEventListener('ui:hydrate', (event) => {
    const target = event.detail?.target || event.target
    init(target)
  })
})()
